// pages/About.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function AboutENG() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page" >
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

        <style jsx>{`
          @media (max-width: 768px) {
            .about-page > div:first-child {
              padding: 60px 0 30px !important;
              min-height: 300px !important;
            }
            .about-page h1 {
              font-size: 2.5rem !important;
            }
            .about-page h3 {
              font-size: 1.5rem !important;
            }
          }
        `}</style>

        <h1 style={{
          fontSize: '3.5rem',
          marginBottom: '20px',
          background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          direction: 'ltr'
        }}>
          National campaign to end digital violence against women and girls
        </h1>

        <h3 style={{
          fontSize: '2rem',
          marginBottom: '20px',
          fontWeight: '600',
          lineHeight: '1.6',
          direction: 'ltr'
        }}>
        A silent digital pandemic threatening society
        </h3>

        <div style={{
          background: 'var(--secondary-black)',
          padding: '20px 30px',
          borderRadius: '15px',
          borderRight: '4px solid var(--primary-orange)',
          marginBottom: '25px',
          direction: 'ltr'
        }}>
          <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
          <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>Dates:</strong> November 25 – December 10, 2025
          </p>
          <p style={{ fontSize: '1.3rem' }}>
            <img src="/images/duration.png" className="tab-icon3-img" /> <strong>Duration:</strong> 16 Days
          </p>
        </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0', direction: 'ltr' }}>
        <div className="container">
          {/* Campaign Introduction */}
          <div style={{
            background: 'var(--primary-black)',
            padding: '50px 40px',
            borderRadius: '20px',
            marginBottom: '50px',
            border: '2px solid rgba(255, 107, 53, 0.3)',
            direction: 'ltr'
          }}>
            <h2 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--primary-orange)',
              textAlign: 'center',
              direction: 'ltr'
            }}>
              A silent digital pandemic threatening society
            </h2>

            <div style={{
              fontSize: '1.2rem',
              lineHeight: '2',
              color: 'var(--text-light)',
              textAlign:'left'
            }}>

            <p style={{ marginBottom: '20px' }}>
        Violence against women and girls is <strong style={{ color: 'var(--primary-orange)' }}>the most widespread human rights violation in the world</strong>. One in three women experiences at least one form of GBV in their lifetime.
      </p>

      <p style={{ marginBottom: '20px' }}>
        As modern technologies and social media grow rapidly, <strong style={{ color: 'var(--primary-orange)' }}>violence against women and girls</strong> has transformed into complex digital forms, with technology amplifying its psychological, social, and legal consequences.
      </p>

            </div>
          </div>

          {/* Alarming Statistics */}
          <div style={{ marginBottom: '60px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Alarming global data
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  16-58%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  of women and girls have experienced digital violence globally
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  14-16
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
              Age at which girls first experience cyber harassment
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  60%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  of women in the Arab region experience some form of digital violence
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  95%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  of pornographic "deepfake" content targets women
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  44%
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  of digital violence cases spill into real life
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '4rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '15px'
                }}>
                  1.5M
                </div>
                <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                  Moroccan women experience digital violence every year
                </p>
              </div>
            </div>
          </div>

          {/* Most Common Forms */}
          <div style={{ marginBottom: '60px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
            }}>
              Most common forms of digital violence
            </h3>

            <div style={{
              display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '24px',

            }}>
              {[
                { percentage: '67%', text: 'Defamation and disinformation' },
                { percentage: '66%', text: 'Cyber harassment' },
                { percentage: '65%', text: 'Hate speech' },
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  textAlign: 'center',
                  direction: 'ltr',
                      alignContent: 'center'
                }}>
                  {item.percentage && (
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '700',
                      color: 'var(--primary-orange)',
                      marginBottom: '15px'
                    }}>
                      {item.percentage}
                    </div>
                  )}
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                    {item.text}
                  </p>
                </div>
              ))}
            </div>

            <div style={{
              display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '24px',
                marginTop: '25px'

            }}>
              {[
                { percentage: '', text: 'Cyberbullying and blackmail' },
                { percentage: '', text: 'Online human trafficking' },
                { percentage: '', text: 'AI-powered deepfakes' }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  textAlign: 'center',
                  direction: 'ltr',
                      alignContent: 'center'
                }}>
                  {item.percentage && (
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '700',
                      color: 'var(--primary-orange)',
                      marginBottom: '15px'
                    }}>
                      {item.percentage}
                    </div>
                  )}
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                    {item.text}
                  </p>
                </div>
              ))}
            </div>


          </div>

          <div className="section-separator"></div>

          {/* Morocco Situation */}
          <div style={{ marginBottom: '60px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              The situation in Morocco
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
              gap: '30px',
              marginBottom: '40px',
              textAlign:'left'
            }}>
              {/* Most Vulnerable Groups */}
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                border: '2px solid rgba(255, 107, 53, 0.3)',
                direction: 'ltr'
              }}>
                <h4 style={{
                  fontSize: '1.8rem',
                  marginBottom: '20px',
                  color: 'var(--primary-orange)',
                  direction: 'ltr'
                }}>
                  Groups most vulnerable to digital violence
                </h4>
                <div style={{ fontSize: '1.1rem', lineHeight: '2' }}>
                  <p style={{ marginBottom: '10px' }}>• <strong>16%</strong> Women in urban areas</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>29%</strong> Girls aged 15-19</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>25%</strong> Women with higher education</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>30%</strong> Single women</p>
                  <p>• <strong>36%</strong> Students</p>
                </div>
              </div>

              {/* Perpetrator Identity */}
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                border: '2px solid rgba(255, 107, 53, 0.3)',
                direction: 'ltr'
              }}>
                <h4 style={{
                  fontSize: '1.8rem',
                  marginBottom: '20px',
                  color: 'var(--primary-orange)',
                  direction: 'ltr'
                }}>
                  Perpetrators
                </h4>
                <div style={{ fontSize: '1.1rem', lineHeight: '2' }}>
                  <p style={{ marginBottom: '10px' }}>• <strong>73%</strong> Unidentified men</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>4%</strong> Current or former partners</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>4%</strong> Family members</p>
                  <p style={{ marginBottom: '10px' }}>• <strong>4%</strong> Classmates or colleagues</p>
                  <p>• <strong>4%</strong> Friends</p>
                </div>
              </div>

              {/* Reporting Problem */}
              <div style={{
                background: 'var(--primary-black)',
                padding: '35px',
                borderRadius: '15px',
                border: '2px solid rgba(255, 107, 53, 0.3)',
                direction: 'ltr'
              }}>
                <h4 style={{
                  fontSize: '1.8rem',
                  marginBottom: '20px',
                  color: 'var(--primary-orange)',
                  direction: 'ltr'
                }}>
                  Reporting challenges
                </h4>
                <div style={{ fontSize: '1.1rem', lineHeight: '2' }}>
                  <div style={{
                    padding: '20px',
                    background: 'rgba(255, 107, 53, 0.1)',
                    borderRadius: '10px',
                    marginBottom: '15px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--primary-orange)' }}>
                      11%
                    </div>
                    <p>of female journalists report online violence</p>
                  </div>
                  <div style={{
                    padding: '20px',
                    background: 'rgba(255, 107, 53, 0.1)',
                    borderRadius: '10px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '3rem', fontWeight: '700', color: 'var(--primary-orange)' }}>
                      8%
                    </div>
                    <p>take legal action</p>
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.15), rgba(255, 133, 85, 0.08))',
              padding: '35px',
              borderRadius: '15px',
              border: '2px solid rgba(255, 107, 53, 0.3)',
              textAlign: 'center',
              marginTop: '30px',
              direction: 'ltr'
            }}>
              <p style={{ fontSize: '1.3rem', lineHeight: '2', color: 'var(--text-light)' }}>
              Digital attacks are becoming increasingly severe against women with a visible presence in public life, especially those working in media, politics, and human rights. These attacks, ranging from <strong style={{ color: 'var(--primary-orange)' }}>defamation, threats, discrimination, verbal abuse, harassment, and sexual violence</strong>, violate women's right to freedom of expression and participation in public life.
              </p>
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Campaign Organizer */}
          <div style={{ marginTop: '60px', marginBottom: '60px', direction: 'ltr' }}>


            <div style={{
              background: 'var(--primary-black)',
              padding: '50px 40px',
              borderRadius: '20px',
              border: '2px solid var(--primary-orange)',
              direction: 'ltr'
            }}>
            <h4 style={{
    fontSize: '2.2rem',

    color: 'var(--primary-orange)',
    textAlign: 'center',
    direction: 'ltr'
  }}>
    Speak out against gender-based violence 2025
  </h4>

  <h5 style={{
    fontSize: '1.8rem',
    fontStyle: 'italic',
    textAlign: 'center',
    color: 'var(--text-light)',
    direction: 'ltr',
      marginBottom: '25px',
  }}>
    Mansktouch Ala El Onf 2025
  </h5>


              <div style={{
    fontSize: '1.15rem',
    lineHeight: '2',
    color: 'var(--text-light)',
    justifySelf: 'center',
    direction: 'ltr'
  }}>

              <p style={{ marginBottom: '20px' }}>
  A national campaign launched by the <strong style={{ color: 'var(--primary-orange)' }}>National Human Rights Council</strong> to end violence against women and girls.
</p>


                <p>
                An itinerant campaign that will travel across Morocco to raise awareness about technology-facilitated violence against women and girls.
                </p>
                <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '1.3rem', color: 'var(--primary-orange)' }}>
                  <strong>November 25 – December 10</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Campaign Objectives */}
          <div style={{ marginBottom: '60px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Campaign objectives
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '30px'
            }}>
              {[
                {
                  icon: '🛡️',
                  title: 'Protection and Mobilization',
                  desc: 'Strengthening the protection of women\'s and girls\' rights in the digital space and the age of AI'
                },
                {
                  icon: '📚',
                  title: 'Education and Knowledge',
                  desc: 'Highlighting rights-violating technological uses and promoting measures to prevent them'
                },
                {
                  icon: '🔔',
                  title: 'Awareness and Reporting',
                  desc: 'Promoting digital safety and encouraging victims to report incidents of digital violence'
                },
                {
                  icon: '🔊',
                  title: 'Breaking the Silence',
                  desc: 'Promoting reporting mechanisms and encouraging victims to speak up and report technology facilitated GBV'
                }
              ].map((objective, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '35px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  textAlign: 'center',
                  transition: 'all 0.3s ease',
                  direction: 'ltr'
                }}>
                  <div style={{ fontSize: '3.5rem', marginBottom: '20px' }}>{objective.icon}</div>
                  <h4 style={{
                    fontSize: '1.6rem',
                    marginBottom: '15px',
                    color: 'var(--primary-orange)'
                  }}>
                    {objective.title}
                  </h4>
                  <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-light)' }}>
                    {objective.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Call to Action */}
          <div style={{ textAlign: 'center', marginTop: '60px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Welcome to the campaign booths
            </h3>
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '30px',
              color: 'var(--text-light)',
              lineHeight: '1.8',
              direction: 'ltr'
            }}>
              We welcome you to join this campaign and look forward to your interactions and suggestions to contribute to a safe and fair digital space for all.
            </p>

            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '20px'
            }}>


            </div>

            <p style={{
              fontSize: '1.2rem',
              marginTop: '40px',
              color: 'var(--text-light)',
              fontStyle: 'italic',
              direction: 'ltr'
            }}>
            Together we break the wall of silence | Together we stand against the silent digital pandemic
            </p>
          </div>


        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default AboutENG;
